export default {
  actualValue: 'Aktualna wartość',
};
